import { UUID } from "../generic/uuid";

import { createRegionDtoFromOfferRegionModel, RegionModel } from "./region";
import {
  createWineTypeDtoFromOfferWineTypeModel,
  WineTypeModel,
} from "./wineType";
import { createWineryDtoFromOfferWineryModel, WineryModel } from "./winery";
import { WineDto } from "@vini-wine/core-dtos";

export interface WineModel extends UUID {
  // transform
  name: string;

  // available includes
  region?: RegionModel;
  wineType?: WineTypeModel;
  winery?: WineryModel;
}

export const createWineDtoFromOfferWineModel = (wine: WineModel): WineDto => {
  return {
    uuid: wine.uuid,
    name: wine.name,
    region: wine.region
      ? createRegionDtoFromOfferRegionModel(wine.region)
      : undefined,
    winery: wine.winery
      ? createWineryDtoFromOfferWineryModel(wine.winery)
      : undefined,
    wineType: wine.wineType
      ? createWineTypeDtoFromOfferWineTypeModel(wine.wineType)
      : undefined,
  };
};
